<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineProps<{
  provider: string
  label: string
  icon: IconDefinition | string
}>()
</script>

<template>
  <NuxtLink external :href="provider" class="flex items-center gap-xs hover:text-white" target="_blank">
    <div class="rounded-full border-2 p-2">
      <img v-if="typeof icon === 'string'" :src="icon" alt="" class="size-5 aspect-square min-w-5">
      <Icon v-else :icon="icon" class="block" />
    </div>

    <span class="hidden md:inline" v-text="label" />
  </NuxtLink>
</template>
